import type { CrmRailView, IntakeSubmissionView, Page, TimelineItem } from '@takeit4me/shared'
import type { Http } from '../http'

export type TimelineScope = { person_id?: string; organisation_id?: string; conversation_id?: string }

/** Console API methods: workstream A (records core, history, timeline). */
export interface RecordsApi {
  /** Counts for the CRM rail: invoices, conversations and tasks. */
  crmRail(): Promise<CrmRailView>
  /** One page of a timeline, newest first; pass `next_cursor` back for older items. */
  timelinePage(q: TimelineScope & { cursor?: string | null; limit?: number }): Promise<Page<TimelineItem>>
  /** A custom record's own history (every change, undos included), newest first. */
  recordHistory(object: string, id: string, q?: { cursor?: string | null; limit?: number }): Promise<Page<TimelineItem>>
  /** The website form a record came from: its marketing attribution, what the customer agreed to, and the chat it came from. */
  recordSubmissions(object: string, id: string): Promise<IntakeSubmissionView[]>
  /**
   * Undoes a change. When the thing has changed since, the API answers 409 with code `stale` and
   * details `{ fields, later }`; call again with `force: true` once the person has confirmed.
   */
  undo(id: string, opts?: { force?: boolean }): Promise<{ ok: true }>
}

const enc = encodeURIComponent

export const recordsMethods = (http: Http): RecordsApi => ({
  crmRail: () => http.get<CrmRailView>('/crm/rail'),
  timelinePage: (q) => http.get<Page<TimelineItem>>('/crm/timeline/page', q),
  recordHistory: (object, id, q = {}) => http.get<Page<TimelineItem>>(`/crm/records/${enc(object)}/${enc(id)}/history`, q),
  recordSubmissions: (object, id) => http.get<IntakeSubmissionView[]>(`/crm/records/${enc(object)}/${enc(id)}/submissions`),
  undo: (id, opts = {}) => http.post<{ ok: true }>(`/crm/changes/${enc(id)}/undo`, opts.force ? { force: true } : undefined),
})
